// מעקב Google Analytics (GA4) — נטען רק אם הוגדר מזהה ב-config.js.
// עוקב אחרי צפיות בעמודים ואחרי הפעולות החשובות: לחיצות חיוג, וואטסאפ ושליחת טופס.
import { GA_MEASUREMENT_ID } from './config';

let initialized = false;

export function initAnalytics() {
  if (initialized || !GA_MEASUREMENT_ID) return;
  initialized = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });
}

export function trackPageView(path) {
  if (!window.gtag) return;
  window.gtag('event', 'page_view', { page_path: path, page_location: window.location.href });
}

export function trackEvent(name, params = {}) {
  if (!window.gtag) return;
  window.gtag('event', name, params);
}
